import type React from 'react'

/**
 * Warning triangle (24 × 24) — StatusBanner icon for `variant="restricted"`.
 *
 * Path data is byte-identical to
 * `metro/docs/superpowers/specs/assets/stationcard-v2/icon-warning-triangle.svg`
 * (Figma export). Stroke + fill are bound to `currentColor` so the
 * banner can tint via the warning foreground token.
 */
export function IconWarningTriangle(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M12 3L22 20H2L12 3Z"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10V14.5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.5C12.5523 18.5 13 18.0523 13 17.5C13 16.9477 12.5523 16.5 12 16.5C11.4477 16.5 11 16.9477 11 17.5C11 18.0523 11.4477 18.5 12 18.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
